/**
 * Key-document slot roles (eReg source-of-truth plan §3.2) — the single
 * FRONTEND copy of the role taxonomy. The backend copy is canonical
 * (backend/src/services/studyDocuments.js: KEY_DOCUMENT_ROLES /
 * KEY_DOCUMENT_ROLE_LABELS / TYPE_TO_ROLE) — keep these in lock-step when a
 * role is added. Where an API response carries role_labels, prefer it over
 * this map.
 */

export const STUDY_ROLE_LABELS: Record<string, string> = {
  protocol: 'Protocol',
  icf: 'Informed Consent Form',
  ib: 'Investigator Brochure',
  lab_cert: 'Lab Certification',
  pharmacy_manual: 'Pharmacy Manual',
};

/** Slot role → eReg document type (inverse of the backend's TYPE_TO_ROLE). */
export const ROLE_TO_DOCUMENT_TYPE: Record<string, string> = {
  protocol: 'Protocol',
  icf: 'Informed Consent Form',
  ib: 'Investigator Brochure',
  lab_cert: 'Lab Certification',
  pharmacy_manual: 'Pharmacy Documentation',
};

/**
 * Popup-blocker-safe presigned-URL opener: the window MUST be opened
 * synchronously inside the click gesture (blockers reject window.open after
 * an await), and 'noopener' in the features string makes window.open return
 * null per spec — so open about:blank, null the opener, then point the
 * window at the fetched URL.
 */
export async function openPresigned(fetchUrl: () => Promise<string>): Promise<boolean> {
  const win = window.open('about:blank', '_blank');
  if (win) win.opener = null;
  try {
    const url = await fetchUrl();
    if (win) {
      win.location.href = url;
    } else {
      window.open(url, '_blank', 'noopener');
    }
    return true;
  } catch (err) {
    if (win) win.close();
    return false;
  }
}
